import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Header from './Header';

const ModalUploadPlotsForm = () => {
    const server_app_api_php = window.SERVER_APP_API_PHP;
  const [uploadMethod, setUploadMethod] = useState('');
  const [businessLocationID, setBusinessLocationID] = useState('');
  const [plotArea, setPlotArea] = useState('');
  const [plotNumber, setPlotNumber] = useState('');
  const [plotPrice, setPlotPrice] = useState('');
  const [plotStatus, setPlotStatus] = useState('');
  const [excelPlots, setExcelPlots] = useState(null);
  const [businessLocations, setBusinessLocations] = useState([]);

  const userCompanyID = 1; // replace with actual value
  const userBusinessLocationID = ''; // replace with actual value

  useEffect(() => {
    // Create formData object
    const formData = new FormData();
    formData.append("apiType", 'getBusinessLocationPlotsOnUploadForm');
    formData.append("companyID", userCompanyID);
    formData.append("location", userBusinessLocationID);
    // Fetch plot options from the backend using POST method
    axios.post(`${server_app_api_php}/server/index.php`, formData)
      .then(response => {
        setBusinessLocations(response.data);
      })
      .catch(error => {
        //alert("There was an error fetching the Business Locations!", error);
      });
    }, []);


  const handleUploadMethodChange = (e) => {
    setUploadMethod(e.target.value);
  };

  const handleExcelFileChange = (e) => {
    setExcelPlots(e.target.files[0]);
  };

  const handleSingleFormSubmit = async (e) => {
    e.preventDefault();
    const formData = new FormData();
    formData.append("apiType", 'registerPlots');
    formData.append("companyID", userCompanyID);
    formData.append("businessLocationID", userBusinessLocationID);
    formData.append("plotArea", plotArea);
    formData.append("plotNumber", plotNumber);
    formData.append("plotPrice", plotPrice);
    formData.append("plotStatus", plotStatus);
    formData.append("business_locationIDPlots", businessLocationID );
    // Fetch plot options from the backend using POST method
    axios.post(`${server_app_api_php}/server/index.php`, formData)
      .then(response => {
        if (response.data === 'Successful') {
            alert('Successfully Uploaded');
            setPlotArea('');
            setPlotNumber('');
            setPlotPrice('');
            setPlotStatus('');
            setUploadMethod('');
            setExcelPlots(null);
            setBusinessLocationID('');
          } else if (response.data === 'Failed') {
            alert('Failed to Upload. Contact Support Team');
          } else if (response.data === 'Duplicate') {
            alert('Failed to Upload. Duplicate Entry');
          }
      })
      .catch(error => {
        alert('There Seems To be a Problem with Your Internet Connectivity. If this Problem continues, kindly contact Support Team');
      });

  };

  const handleExcelFormSubmit = async (e) => {
    e.preventDefault();
    const formData = new FormData();
    formData.append('apiType', 'registerPlotsExcel');
    formData.append('excelPlots', excelPlots);
    formData.append('companyID', userCompanyID);
    formData.append('businessLocationID', businessLocationID);
    // Fetch plot options from the backend using POST method
    axios.post(`${server_app_api_php}/server/index.php`, formData)
      .then(response => {
        if (response.data === 'Upload Completed Successfully' || response.data === '') {
            alert('Plots Upload Completed Successfully');
            setExcelPlots(null);
            setBusinessLocationID('');
          } else {
            alert(response.data);
          }
      })
      .catch(error => {
        alert('Error: Please Check Your Internet Connection. If This Persists, Kindly Contact Support Team');
    });
  };

  return (
    <>
    <Header />
    <hr />
    <div className="mt-5" id="modalUploadPlotsForm" tabIndex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
      <div className="modal-dialog modal-lg modal-notify modal-info" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <p className="heading lead">Register Plots</p>
         
          </div>
          <div className="modal-body">
            <div className="row">
              <div className="col-lg-12 col-xl-12 col-md-12 md-form md-outline">
                <select className="custom-select d-block w-100" id="uploadMethodPlots" name="uploadMethodPlots" value={uploadMethod} onChange={handleUploadMethodChange}>
                  <option value="">Choose Upload Method..</option>
                  <option value="Single Form">Single Form</option>
                  <option value="Upload Excel File">Upload Excel File</option>
                </select>
              </div>
            </div>
            {uploadMethod === 'Upload Excel File' && (
              <div className="row" id="uploadExcelFilePlots">
                <form name="fileUploadFormPlots" id="fileUploadFormPlots" onSubmit={handleExcelFormSubmit}>
                  <div className="col-lg-12 col-xl-12 col-md-12 md-form md-outline">
                    <select className="custom-select d-block w-100" id="business_locationIDPlotsExcel" name="business_locationIDPlotsExcel" value={businessLocationID} onChange={(e) => setBusinessLocationID(e.target.value)} required>
                      <option value="">Choose Business Location..</option>
                      {businessLocations.map((location) => (
                        <option key={location.businessLocationID} value={location.businessLocationID}>
                          {location.businessLocationName}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="col-lg-12 col-xl-12 col-md-12 md-form md-outline">
                    <label htmlFor="form22">Select Excel File</label><br />
                    <div className="md-form md-outline">
                      <input type="file" id="excelPlots" name="excelPlots" className="form-control form-control-sm" onChange={handleExcelFileChange} />
                      <input type="hidden" id="companyID" name="companyID" value={userCompanyID} />
                      <input type="hidden" id="businessLocationID" name="businessLocationID" value={userBusinessLocationID} />
                      <input type="hidden" id="apiType" name="apiType" value="registerPlotsExcel" />
                    </div>
                  </div>
                  <div className="text-center mt-0">
                    <button className="btn btn-success" id="registerPlotsExcel">Upload <i className="fas fa-pen-alt ml-1"></i></button>
                  </div>
                </form>
              </div>
            )}
            {uploadMethod === 'Single Form' && (
              <div className="row" id="singleFormPlots">
                <form onSubmit={handleSingleFormSubmit}>
                  <div className="col-lg-12 col-xl-12 col-md-12 md-form md-outline">
                    <select className="custom-select d-block w-100" id="business_locationIDPlots" name="business_locationIDPlots" value={businessLocationID} onChange={(e) => setBusinessLocationID(e.target.value)}>
                      <option value="">Choose Business Location..</option>
                      {businessLocations.map((location) => (
                        <option key={location.businessLocationID} value={location.businessLocationID}>
                          {location.businessLocationName}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className='row'>
                  <div className="col-lg-6 col-xl-6 col-md-12 md-form md-outline">
                    <div className="md-form md-outline">
                      <input type="text" id="plotNumberPlots" className="form-control" value={plotNumber} onChange={(e) => setPlotNumber(e.target.value)} />
                      <label htmlFor="form22">Plot Number</label>
                    </div>
                  </div>
                  <div className="col-lg-6 col-xl-6 col-md-12 md-form md-outline">
                    <div className="md-form md-outline">
                      <input type="text" id="plotArea" className="form-control" value={plotArea} onChange={(e) => setPlotArea(e.target.value)} />
                      <label htmlFor="form23">Plot Area</label>
                    </div>
                  </div>
                  
                  <div className="col-lg-6 col-xl-6 col-md-12 md-form md-outline">
                    <div className="md-form md-outline">
                      <input type="text" id="plotPrice" className="form-control" value={plotPrice} onChange={(e) => setPlotPrice(e.target.value)} />
                      <label htmlFor="form22">Plot Price</label>
                    </div>
                  </div>
                  <div className="col-lg-6 col-xl-6 col-md-12 md-form md-outline">
                    <div className="md-form md-outline">
                      <input type="text" id="plotStatus" className="form-control" value={plotStatus} onChange={(e) => setPlotStatus(e.target.value)} />
                      <label htmlFor="form23">Plot Status</label>
                    </div>
                  </div>
                  <div className="text-center mt-0">
                    <button type="submit" className="btn btn-success" id="registerPlots">Register <i className="fas fa-pen-alt ml-1"></i></button>
                  </div>

                  </div>
                </form>
              </div>
            )}
          </div>
          <div className="modal-footer">

          </div>
        </div>
      </div>
    </div>
    </>
  );
};

export default ModalUploadPlotsForm;
